import {AuthRefKey} from "../../../core/constants/constants";

export function getAuthRef() {
    const authRef = localStorage.getItem(AuthRefKey)
    if(authRef)
    {
        return authRef
            .replace('https://', '')
            .replace('http://', '')
            .replace('://', '')
            .replace('//', '');
    }
    return ''
}

export function setAuthRef(authRef) {
    localStorage.setItem(AuthRefKey, authRef)
}

export function removeAuthRef() {
    localStorage.setItem(AuthRefKey, null)
    localStorage.removeItem(AuthRefKey)
}